import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Contexts
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';

// Components
import Header from './components/Header';
import BottomNav from './components/BottomNav';
import MobileMenu from './components/MobileMenu';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ProductList from './pages/ProductList';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderConfirmation from './pages/OrderConfirmation';
import MyOrders from './pages/MyOrders';
import OrderDetail from './pages/OrderDetail';
import MyAccount from './pages/MyAccount';
import Coverage from './pages/Coverage';
import Contact from './pages/Contact';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <div className="min-h-screen bg-background">
            {/* Header - Hidden on auth pages */}
            <Routes>
              <Route path="/login" element={null} />
              <Route path="/register" element={null} />
              <Route path="*" element={
                <Header onMenuClick={() => setIsMenuOpen(true)} />
              } />
            </Routes>

            {/* Mobile Menu */}
            <MobileMenu 
              isOpen={isMenuOpen} 
              onClose={() => setIsMenuOpen(false)} 
            />

            {/* Main Content */}
            <main>
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/productos" element={<ProductList />} />
                <Route path="/productos/:slug" element={<ProductDetail />} />
                <Route path="/carrito" element={<Cart />} />
                <Route path="/cobertura" element={<Coverage />} />
                <Route path="/contacto" element={<Contact />} />

                {/* Protected Routes */}
                <Route 
                  path="/checkout" 
                  element={
                    <ProtectedRoute>
                      <Checkout />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/pedido-confirmado" 
                  element={
                    <ProtectedRoute>
                      <OrderConfirmation />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/pedidos" 
                  element={
                    <ProtectedRoute>
                      <MyOrders />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/pedidos/:code" 
                  element={
                    <ProtectedRoute>
                      <OrderDetail />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/cuenta" 
                  element={
                    <ProtectedRoute>
                      <MyAccount />
                    </ProtectedRoute>
                  } 
                />

                {/* 404 */}
                <Route 
                  path="*" 
                  element={
                    <div className="min-h-screen flex items-center justify-center px-4">
                      <div className="text-center">
                        <h1 className="text-6xl font-display font-bold text-[#E85D04] mb-4">
                          404
                        </h1>
                        <h2 className="text-2xl font-display font-bold text-[#1B263B] mb-2">
                          Página no encontrada
                        </h2>
                        <p className="text-[#7A756F] mb-6">
                          La página que buscas no existe o ha sido movida.
                        </p>
                        <a 
                          href="/"
                          className="inline-flex items-center justify-center px-6 py-3 bg-[#E85D04] text-white font-semibold rounded-xl hover:bg-[#C44A00] transition-colors"
                        >
                          Volver al inicio
                        </a>
                      </div>
                    </div>
                  } 
                />
              </Routes>
            </main>

            {/* Bottom Navigation - Hidden on auth pages */}
            <Routes>
              <Route path="/login" element={null} />
              <Route path="/register" element={null} />
              <Route path="*" element={<BottomNav />} />
            </Routes>
          </div>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
